import React, { useEffect, useState } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import '../styles/relatorioIngressos.scss';

const RelatorioIngressos = () => {
    const [ingressos, setIngressos] = useState({});
    const [totalPorAno, setTotalPorAno] = useState({});
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [filteredIngressos, setFilteredIngressos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const ingressosPorPagina = 10;

    const fetchIngressos = async (month, year) => {
        try {
            const response = await api.get(`/relatorio/ingressos/${month}/${year}`);
            setIngressos(response.data.ingressos);
            setTotalPorAno(response.data.totalPorAno);
            setFilteredIngressos(Object.entries(response.data.ingressos).map(([polo, quantidade]) => ({
                'POLO': polo,
                'INGRESSOS': quantidade,
            })));
        } catch (error) {
            console.error('Erro ao buscar relatório de ingressos:', error);
        }
    };

    useEffect(() => {
        fetchIngressos(selectedMonth, selectedYear);
    }, [selectedMonth, selectedYear]);

    const downloadExcel = () => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredIngressos);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório de Ingressos');

        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', '');

        const fileName = `RelatorioIngressos-${selectedMonth}-${selectedYear}—${formattedDate}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    const indexOfLastIngreso = currentPage * ingressosPorPagina;
    const indexOfFirstIngreso = indexOfLastIngreso - ingressosPorPagina;
    const currentIngressos = filteredIngressos.slice(indexOfFirstIngreso, indexOfLastIngreso);
    const totalPages = Math.ceil(filteredIngressos.length / ingressosPorPagina);

    const getPaginationButtons = () => {
        const buttons = [];
        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Relatório de Alunos Ingressos</h1>
            <div className="alunos-filters">
                <label>Mês:</label>
                <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                    {[...Array(12)].map((_, index) => (
                        <option key={index} value={index + 1}>{index + 1}</option>
                    ))}
                </select>
                <label>Ano:</label>
                <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                    {[2020, 2021, 2022, 2023, 2024, 2025].map((year) => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
                {/* <button onClick={() => fetchIngressos(selectedMonth, selectedYear)}>Buscar</button> */}
                <button className='btn-downloadExcelIngressos'style={{marginLeft: '10px'}} onClick={downloadExcel}>Download Excel</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Polo</th>
                        <th>Ingressos</th>
                    </tr>
                </thead>
                <tbody>
                    {currentIngressos.map((ingresso, index) => (
                        <tr key={index}>
                            <td>{ingresso['POLO']}</td>
                            <td>{ingresso['INGRESSOS']}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."}>{page}</button>
                ))}
            </div>
        </div>
    );
};

export default RelatorioIngressos;
